/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';
import { Loader, ModalGeneric, Table, Accordion } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import useToast from '../../../hooks/useToast';
import { checkRol } from '../../../security';
import {
  aprobador,
  inspector,
  notificador,
  proveedorAdministrador,
  proveedorNotificador
} from '../../../security/constantsRols';
import {
  getAttachmentsDaily,
  getFilesDownloadOptions,
  postAttachmentsDaily
} from '../../../services/workReport';
import {
  getFilesRequestSDS,
  postFilesRequestSDS
} from '../../../services/serviceRequestAttachment';
import { capitalize, formatDate, formatDateToSpanish } from '../../../utils/formatUtils';
import useRequestDetailPermissions from '../../../hooks/useRequestDetailPermissions';
import { assignmentTypeEnum } from '../../../utils/dataStatus';

import AttachFileButtonHeader from './AttachFileButtonHeader/AttachFileButtonHeader';
import NoAttachments from './NoAttachments/NoAttachments';
import '../WorkReportModals.scss';

const justify = {
  textAlign: 'center',
  padding: 20
};

const AttachFileModal = ({
  show,
  onHide,
  onAccept,
  dailyWorkReportId,
  positionName,
  lineName,
  um,
  quantity,
  requestId,
  type,
  date
}) => {
  // Adjuntos pos-lin
  const [dataFiles, setDataFiles] = useState([]);
  const [select, setSelect] = useState([]);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [allDataFiles, setAllDataFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = useState(false);

  // Adjuntos Solicitud
  const [dataRequestFiles, setDataRequestFiles] = useState([]);
  const [selectRequest, setSelectRequest] = useState([]);
  const [attachedRequestFiles, setAttachedRequestFiles] = useState([]);
  const [allDataRequestFiles, setAllDataRequestFiles] = useState([]);
  const [idRequest, setIdRequest] = useState();

  const [loading, setLoading] = useState(false);
  const [disableButton, setDisableButton] = useState();
  const { setNewToast } = useToast();
  const { permissions } = useRequestDetailPermissions({
    notifyTo: 3,
    isASDS: true,
    isOyM: false
  });
  const location = useLocation();

  const canEdit =
    (checkRol(notificador) ||
      checkRol(proveedorAdministrador) ||
      checkRol(aprobador) ||
      checkRol(proveedorNotificador) ||
      checkRol(inspector)) &&
    true;
  const { day, month, year } = formatDateToSpanish(date);

  const [downloadOptions, setDownloadOptions] = useState([]);

  useEffect(() => {
    const getOptions = async () => {
      const options = await getFilesDownloadOptions();

      setDownloadOptions(options.sort((a, b) => a.id - b.id));
    };

    getOptions();
  }, []);

  useEffect(() => {
    const dataUploadedFiles =
      attachedFiles?.map((file) => file?.data).filter((data) => data?.nombre) || [];

    setAllDataFiles([...dataFiles, ...dataUploadedFiles]);
  }, [attachedFiles, dataFiles]);

  useEffect(() => {
    const dataUploadedRequestFiles =
      attachedRequestFiles?.map((file) => file?.data).filter((data) => data?.nombre) || [];

    setAllDataRequestFiles([...dataRequestFiles, ...dataUploadedRequestFiles]);
  }, [attachedRequestFiles, dataRequestFiles]);

  useEffect(() => {
    if (!requestId) {
      const locSplit = location.pathname.split('/');

      setIdRequest(Number(locSplit[2]));
    }
  }, []);

  const selectAll = () => {
    if (select.length < allDataFiles.length) {
      const ids = allDataFiles.map((item) => item.id);

      setSelect(ids);
    } else {
      setSelect([]);
    }
  };

  const selectRequestAll = () => {
    if (selectRequest.length < allDataRequestFiles.length) {
      const ids = allDataRequestFiles.map((item) => item.id);

      setSelectRequest(ids);
    } else {
      setSelectRequest([]);
    }
  };

  const handleChangeSelect = (item) => {
    if (select.includes(item)) {
      const newSelect = select.filter((name) => name !== item);

      setSelect(newSelect);

      return;
    }
    setSelect([...select, item]);
  };

  const handleChangeRequestSelect = (item) => {
    if (selectRequest.includes(item)) {
      const newSelect = selectRequest.filter((name) => name !== item);

      setSelectRequest(newSelect);

      return;
    }
    setSelectRequest([...selectRequest, item]);
  };

  const sizeFile = ({ value }) => {
    const valueMb = Math.round(value / 1024);

    return `${valueMb} kb`;
  };

  const handleHide = () => {
    onHide();
    if (!allDataFiles.length && deletedFiles) {
      // Si archivos fueron borrados y se encuentra vacio los archivos de linea, actualiza la página al salir

      onAccept();
    }
  };

  const columns = [
    {
      Header: () => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.length === allDataFiles.length && allDataFiles.length}
            onChange={selectAll}
            type="checkbox"
            value={undefined}
          />
          <div
            style={{
              marginLeft: 10
            }}
          >
            Nombre de Archivo
          </div>
        </div>
      ),
      hideSort: true,
      accessor: 'nombre',
      Cell: ({ row }) => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.includes(row.original.id)}
            onChange={() => handleChangeSelect(row.original.id)}
            type="checkbox"
            value={undefined}
          />
          <p className="ms-2 my-0">{row.values.nombre}</p>
        </div>
      )
    },
    {
      Header: 'Tamaño',
      accessor: 'peso',
      hideSort: true,
      style: justify,
      Cell: sizeFile
    },
    {
      Header: 'Fecha de carga',
      accessor: 'fechaSubida',
      hideSort: true,
      style: justify,
      Cell: formatDate
    },
    {
      Header: 'Usuario',
      accessor: 'usuario',
      hideSort: true,
      style: justify
    }
  ];

  const columnsRequest = [
    {
      Header: () => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={
              selectRequest.length === allDataRequestFiles.length && allDataRequestFiles.length
            }
            onChange={selectRequestAll}
            type="checkbox"
            value={undefined}
          />
          <div
            style={{
              marginLeft: 10
            }}
          >
            Nombre de Archivo
          </div>
        </div>
      ),
      hideSort: true,
      accessor: 'nombre',
      Cell: ({ row }) => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={selectRequest.includes(row.original.id)}
            onChange={() => handleChangeRequestSelect(row.original.id)}
            type="checkbox"
            value={undefined}
          />
          <p className="ms-2 my-0">{row.values.nombre}</p>
        </div>
      )
    },
    {
      Header: 'Tamaño',
      accessor: 'peso',
      hideSort: true,
      style: justify,
      Cell: sizeFile
    },
    {
      Header: 'Fecha de carga',
      accessor: 'fechaSubida',
      hideSort: true,
      style: justify,
      Cell: formatDate
    },
    {
      Header: 'Usuario',
      accessor: 'usuarioSubida',
      hideSort: true,
      style: justify
    }
  ];
  const loadFiles = async () => {
    setLoading(true);
    try {
      const response = await getAttachmentsDaily(dailyWorkReportId);
      const responseRequest = await getFilesRequestSDS(
        requestId || idRequest,
        type === assignmentTypeEnum.Mensualizada
      );

      setDataFiles(response.activos);
      setDataRequestFiles(responseRequest.activos);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (show) loadFiles();
  }, [dailyWorkReportId, show]);

  useEffect(() => {
    if (!show) {
      setDataFiles([]);
      setAttachedFiles([]);
      setAllDataFiles([]);
      setDataRequestFiles([]);
      setAttachedRequestFiles([]);
      setAllDataRequestFiles([]);
      setDeletedFiles(false);
    }
  }, [show]);

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={onHide}
      primaryAction={async () => {
        setDisableButton(true);
        try {
          setNewToast({
            type: 'INFO',
            message: 'Adjuntando archivos, por favor espere.'
          });

          if (attachedFiles.length) {
            const formData = new FormData();
            const onlyFiles = attachedFiles.map((file) => file.file);

            onlyFiles?.forEach((file) => formData.append('archivosAdjunto', file));
            const response = await postAttachmentsDaily(dailyWorkReportId, formData);

            setNewToast({
              type: 'SUCCESS',
              message: response
            });
          }

          if (attachedRequestFiles.length) {
            const formData = new FormData();
            const onlyFiles = attachedRequestFiles.map((file) => file.file);

            onlyFiles?.forEach((file) => formData.append('archivosAdjunto', file));
            await postFilesRequestSDS({
              id: requestId,
              archivosAdjuntos: formData,
              isMonthly: type === assignmentTypeEnum.Mensualizada
            });

            setNewToast({
              type: 'SUCCESS',
              message: 'Los archivos se adjuntaron correctamente.'
            });
          }

          onHide();
          onAccept();
        } catch (err) {
          setNewToast({
            type: 'ERROR',
            message: err.message
          });
        }
        setDisableButton(false);
      }}
      primaryActionDisabled={
        (!attachedFiles.length && !attachedRequestFiles.length) || !canEdit || disableButton
      }
      primaryActionLabel="Agregar"
      secondaryAction={handleHide}
      secondaryActionLabel="Salir"
      show={show}
      size="xl"
      title="Archivos adjuntos"
    >
      <>
        <div className="text-center modal-info">
          Para el día {capitalize(day?.text)}, {day?.number} de {month} de {year}
        </div>
        <hr className="my-4" />

        <div>
          <Accordion title="Archivos de la solicitud">
            <AttachFileButtonHeader
              allDataFiles={allDataRequestFiles}
              archivesId={requestId}
              attachedFiles={attachedRequestFiles}
              dataFiles={dataRequestFiles}
              disableEdit={!canEdit}
              downloadOptions={downloadOptions}
              isMonthly={type === assignmentTypeEnum.Mensualizada}
              name="SDS"
              permissions={permissions?.attachedFiles?.request}
              select={selectRequest}
              setAttachedFiles={setAttachedRequestFiles}
              setDataFiles={setDataRequestFiles}
              setSelect={setSelectRequest}
            />
            {!allDataRequestFiles.length ? (
              <NoAttachments />
            ) : (
              <Table columns={columnsRequest} data={allDataRequestFiles || []} type="light" />
            )}
          </Accordion>
        </div>
        <hr />
        <div>
          <Accordion
            title={`Archivos "${positionName}  ${
              checkRol(aprobador) ? lineName : `${lineName} ${um} ${quantity || ''}`
            }"`}
          >
            <AttachFileButtonHeader
              allDataFiles={allDataFiles}
              archivesId={dailyWorkReportId}
              attachedFiles={attachedFiles}
              dataFiles={dataFiles}
              disableEdit={!canEdit}
              downloadOptions={downloadOptions}
              name="PosLinea"
              permissions={permissions?.attachedFiles?.workPart}
              select={select}
              setAttachedFiles={setAttachedFiles}
              setDataFiles={setDataFiles}
              setDeletedFiles={setDeletedFiles}
              setSelect={setSelect}
            />
            {!allDataFiles.length ? (
              <NoAttachments />
            ) : (
              <Table columns={columns} data={allDataFiles || []} type="light" />
            )}
          </Accordion>
        </div>

        <Loader show={loading} text="CARGANDO" />
      </>
    </ModalGeneric>
  );
};

export default AttachFileModal;

AttachFileModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onAccept: PropTypes.func,
  dailyWorkReportId: PropTypes.number,
  positionName: PropTypes.string,
  lineName: PropTypes.string,
  um: PropTypes.string,
  quantity: PropTypes.number,
  date: PropTypes.string
};

AttachFileModal.defaultProps = {
  show: false,
  onHide: () => {
    /* Empty */
  },
  onAccept: () => {
    /* Empty */
  },
  dailyWorkReportId: null,
  positionName: '',
  lineName: '',
  um: '',
  quantity: 0,
  date: ''
};
